import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">


                                <div className="ilead-rgt thought-structure">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p>Consider the following example of a toy company trying to
                                                come up with a new toy for Christmas: </p>
                                            <div className="ilead_v_sport-outerbox">
                                                <table width="100%" border="0" cellSpacing="0"
                                                       cellPadding="0"
                                                       className="ilead_v_sport ilead_v_sport_new_task sept">
                                                    <tbody>
                                                    <tr>
                                                        <th width="50%" align="left" valign="top"
                                                            className="green_curve">Key Questions
                                                        </th>
                                                        <th width="50%" align="left" valign="top"
                                                            className="green_curve1">Example Replies
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table"> Purpose questions </span>
                                                            <ul className="greenbullet-list">
                                                                <li>What are the reasons for doing this?
                                                                </li>
                                                                <li>What purposes will be served by doing
                                                                    this?
                                                                </li>
                                                                <li>Why are we doing this/do we need to do
                                                                    this?
                                                                </li>
                                                                <li>Why are we doing this now?</li>
                                                            </ul>
                                                        </td>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><p>We are trying to come
                                                            up with a new toy for Christmas that is going to
                                                            wow the kids and be a best seller. </p>
                                                            <p>We need the sales as this is the busiest time
                                                                of the year and we will all get bonuses if
                                                                this is a success. </p></td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table"> Comparisons questions </span>
                                                            <ul className="greenbullet-list">
                                                                <li>What happened the last time we tried
                                                                    this?
                                                                </li>
                                                                <li>Who else has done this - what did they
                                                                    learn?
                                                                </li>
                                                                <li>How is this the same (or different) from
                                                                    similar situations we have experienced?
                                                                </li>
                                                                <li>What factors or variables do we want to
                                                                    change to reach a different/better
                                                                    outcome?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><p>Last year we only got
                                                            to number 25 with our interactive board game and
                                                            number 12 with the latest type of
                                                            rollerblade. </p>
                                                            <p>We need to consider the current trends
                                                                towards health and exercise as well as
                                                                computers. Or do we need to go back to a
                                                                more simple toy?</p>
                                                            <div className="uiheading"><p>We need to learn
                                                                from our competitors e.g. last year's top
                                                                toys - the smart cycle, cartoon character
                                                                masks and toy electric guitar. </p></div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">Viewpoints questions</span>
                                                            <ul className="greenbullet-list ">
                                                                <li>How would this (issue/opportunity) look
                                                                    to our
                                                                    employees/shareholders/families/communities/<br/>neighbours/competitors/customers?
                                                                </li>
                                                                <li>How would a technical expert/non expert
                                                                    frame this issue; what different
                                                                    questions would they ask?
                                                                </li>
                                                                <li>How would an enemy see this issue; how
                                                                    would an ally see it?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><p>We need to conduct
                                                            focus groups with kids, parents, teachers and
                                                            suppliers. </p>
                                                            <p>We need to think about what is going to be
                                                                big for girls and boys, and what age we are
                                                                aiming for, and ask about these different
                                                                groups. </p>
                                                            <p>We need to talk to our suppliers to find out
                                                                about costs for us and for the market. </p>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><span
                                                            className="subtitle-table">Problems questions</span>
                                                            <ul className="greenbullet-list">
                                                                <li>What could stop this from working? What
                                                                    could go wrong?
                                                                </li>
                                                                <li>What if (X) changed, how would that
                                                                    affect things?
                                                                </li>
                                                                <li>How will we overcome any obstacles we
                                                                    anticipate?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td width="50%" align="left" valign="top"
                                                            className="darkgreen"><p> We could miss
                                                            important market information, so we need to be
                                                            thorough. We need to talk to a wide cross
                                                            section of people. </p>
                                                            <p>We need to plan for changes in trends or
                                                                recessions/big market/world events. </p>
                                                            <div className="uiheading"><p>We need to be very
                                                                clear on health and safety of our toy. </p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><span
                                                            className="subtitle-table">Checks questions </span>
                                                            <ul className="greenbullet-list">
                                                                <li>How will we know if we are succeeding;
                                                                    what will tell us that things are
                                                                    better?
                                                                </li>
                                                                <li>What will success look like; what are
                                                                    our success criteria?
                                                                </li>
                                                                <li>What will be the signs that we should
                                                                    stop and try something else?
                                                                </li>
                                                            </ul>
                                                        </td>
                                                        <td width="50%" align="left" valign="top"
                                                            className="lightgreen"><p>We need to know what
                                                            sales we are aiming for in order to make a
                                                            profit and be in the top ten. </p>
                                                            <p>There will be milestones that we have to be
                                                                hitting in the run up to Christmas and we
                                                                have to have a set launch date to maximise
                                                                sales. </p>
                                                            <div className="uiheading"><p>Our marketing
                                                                needs to be as focused as possible on the
                                                                target market. </p></div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}